//BREAKPOINT
export var BREAKPOINT;
(function (BREAKPOINT) {
  BREAKPOINT[BREAKPOINT["SMALL"] = 576] = "SMALL";
  BREAKPOINT[BREAKPOINT["MEDIUM"] = 768] = "MEDIUM";
  BREAKPOINT[BREAKPOINT["LARGE"] = 992] = "LARGE";
  BREAKPOINT[BREAKPOINT["EXTRA_LARGE"] = 1200] = "EXTRA_LARGE";
})(BREAKPOINT || (BREAKPOINT = {}));